import { c as _c } from "react/compiler-runtime";
import { FormInput, PrimaryButton } from '@systemeio/ui';
import { CreateModuleErrorsInterface, CreateModuleInterface } from 'modules/courses/courses/curriculum/types/module-interface';
import { CourseId } from 'modules/courses/courses/types/course-interface';
import React, { useState } from 'react';
import CreateModal from 'shared/components/create-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { fetchWithFieldErrors } from 'shared/utils/fetch-with-errors';
import { AddIcon } from '@systemeio/ui/icons';
const defaultErrors: CreateModuleErrorsInterface = {
  fields: {
    name: ''
  }
};
const defaultValues: CreateModuleInterface = {
  name: ''
};
export interface CreateModuleModalInterface {
  onModuleCreate: (courseId: CourseId, module: CreateModuleInterface) => Promise<void>;
  courseId: CourseId;
  disabled: boolean;
  withIcon?: boolean;
}
const CreateModuleModal = t0 => {
  const $ = _c(30);
  const {
    onModuleCreate,
    courseId,
    disabled,
    withIcon: t1
  } = t0;
  const withIcon = t1 === undefined ? true : t1;
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  const [errors, setErrors] = useState(defaultErrors);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setErrors(defaultErrors);
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const afterLeave = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setOpened(false);
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const onClose = t3;
  let t4;
  if ($[2] !== courseId || $[3] !== onModuleCreate) {
    t4 = async data => {
      await fetchWithFieldErrors(async () => {
        await onModuleCreate(courseId, data);
      }, setErrors);
    };
    $[2] = courseId;
    $[3] = onModuleCreate;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const onCreate = t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setOpened(true);
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = `${withIcon ? "block" : "lg:hidden"} block`;
  let t7;
  if ($[6] !== t6) {
    t7 = <AddIcon className={t6} />;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t) {
    t8 = t("dashboard.course.add_module_modal.trigger_title");
    $[8] = t;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t8) {
    t9 = <span className="whitespace-nowrap">{t8}</span>;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== disabled || $[13] !== t7 || $[14] !== t9) {
    t10 = <PrimaryButton disabled={disabled} className="flex items-center justify-between" onClick={t5} data-test="course-create-module">{t7}{t9}</PrimaryButton>;
    $[12] = disabled;
    $[13] = t7;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t) {
    t11 = t("dashboard.course.module_title");
    $[16] = t;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== errors || $[19] !== t) {
    t12 = [{
      field: "name",
      onRender: (value, onChange) => <FormInput key="course-module-create" label={t("global.name")} value={value} required={true} onChange={e => onChange(e.target.value)} error={errors.fields.name} data-test="course-create-module-name" />
    }];
    $[18] = errors;
    $[19] = t;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = ["name"];
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== onCreate || $[23] !== opened || $[24] !== t11 || $[25] !== t12) {
    t14 = <CreateModal opened={opened} onClose={onClose} afterLeave={afterLeave} defaultValues={defaultValues} caption={t11} creatable={t12} onCreate={onCreate} requiredFields={t13} dataTestKey="course-create-module" />;
    $[22] = onCreate;
    $[23] = opened;
    $[24] = t11;
    $[25] = t12;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t10 || $[28] !== t14) {
    t15 = <>{t10}{t14}</>;
    $[27] = t10;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  return t15;
};
export default CreateModuleModal;